import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const ADMIN_API = `${BACKEND_URL}/api/admin`;

const AdminAuthContext = createContext(null);

export const AdminAuthProvider = ({ children }) => {
  const [admin, setAdmin] = useState(null);
  const [loading, setLoading] = useState(true);

  const checkAdmin = useCallback(async () => {
    try {
      const res = await axios.get(`${ADMIN_API}/me`, { withCredentials: true });
      setAdmin(res.data);
    } catch {
      setAdmin(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { checkAdmin(); }, [checkAdmin]);

  const loginAdmin = async (username, password) => {
    const res = await axios.post(`${ADMIN_API}/login`, { username, password }, { withCredentials: true });
    setAdmin({ username: res.data.username, role: 'admin' });
    return res.data;
  };

  const logoutAdmin = async () => {
    await axios.post(`${ADMIN_API}/logout`, {}, { withCredentials: true });
    setAdmin(null);
  };

  return (
    <AdminAuthContext.Provider value={{ admin, loading, loginAdmin, logoutAdmin }}>
      {children}
    </AdminAuthContext.Provider>
  );
};

export const useAdminAuth = () => {
  const ctx = useContext(AdminAuthContext);
  if (!ctx) throw new Error('useAdminAuth must be used within AdminAuthProvider');
  return ctx;
};
